import mockData from "../../data/mock.json";

const state = () => ({
  basicPage: null,
  title: "Reports",
  details: null,
  sidebar: mockData.sideBarDetails,
  sections: null,
  content:
    "Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum ",
  jurisdictions: [],
  updated: null,
  watching: null,
  relatedContent: null,
  relatedUpdates: null,
  filters: null,
  allWatching: null,
  allJurisdictions: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  appendData(state, data) {
    state[data.label].push(data.data);
  },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.jsonApiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status, `${this.$config.jsonApiURL}${url}`);
      });
  },
  async getViewData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
